import React from 'react';

// 3D Pyramid loader — shown briefly on app entry (max ~1s)
const pyramidStyles = `
    .pyramid-loader {
        position: relative;
        width: 300px;
        height: 300px;
        display: block;
        transform-style: preserve-3d;
        transform: rotateX(-20deg);
    }
    .pyramid-loader .wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
        animation: pyramid-spin 4s linear infinite;
    }
    @keyframes pyramid-spin {
        100% { transform: rotateY(360deg); }
    }
    .pyramid-loader .wrapper .side {
        width: 70px;
        height: 70px;
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        margin: auto;
        transform-origin: center top;
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    }
    .pyramid-loader .wrapper .side1 {
        transform: rotateZ(-30deg) rotateY(90deg);
        background: conic-gradient(#2BDEAC, #F028FD, #D8CCE6, #2F2585);
    }
    .pyramid-loader .wrapper .side2 {
        transform: rotateZ(30deg) rotateY(90deg);
        background: conic-gradient(#2F2585, #D8CCE6, #F028FD, #2BDEAC);
    }
    .pyramid-loader .wrapper .side3 {
        transform: rotateX(30deg);
        background: conic-gradient(#2F2585, #D8CCE6, #F028FD, #2BDEAC);
    }
    .pyramid-loader .wrapper .side4 {
        transform: rotateX(-30deg);
        background: conic-gradient(#2BDEAC, #F028FD, #D8CCE6, #2F2585);
    }
    .pyramid-loader .wrapper .shadow {
        width: 60px;
        height: 60px;
        background: #8B5AD5;
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        margin: auto;
        transform: rotateX(90deg) translateZ(-40px);
        filter: blur(12px);
    }
`;

export const PyramidLoader = () => (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black overflow-hidden">
        <style>{pyramidStyles}</style>
        <div className="pyramid-loader">
            <div className="wrapper">
                <span className="side side1" />
                <span className="side side2" />
                <span className="side side3" />
                <span className="side side4" />
                <span className="shadow" />
            </div>
        </div>
    </div>
);

export default PyramidLoader;